import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from "@chakra-ui/react";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IBreadcrumb } from "@src/services/contentful/breadcrumbs/breadcrumbs";
import React from "react";

export type BreadcrumbsProps = {
  breadcrumbs?: IBreadcrumb[];
};
const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ breadcrumbs }) => {
  console.log("breadcrumbs", breadcrumbs);
  let slug = "";
  let breadcrumbsList;
  if (breadcrumbs) {
    breadcrumbsList =
      breadcrumbs && breadcrumbs.length > 0
        ? breadcrumbs.map((breadcrumb, i) => {
            slug += `/${breadcrumb.slug}`;
            return (
              <BreadcrumbItem
                data-testid="bcitem"
                key={i + 1}
                isCurrentPage={breadcrumbs.length === i + 1}
              >
                <BreadcrumbLink fontSize="sm" href={slug} color="white">
                  {breadcrumb.name}
                </BreadcrumbLink>
              </BreadcrumbItem>
            );
          })
        : null;
  }

  const breadcrumb = breadcrumbs ? (
    <Box
      px={4}
      py={2}
      backgroundColor="#1a4d6b"
      display={["none", "none", "block"]}
    >
      <Breadcrumb spacing={1} separator={<ChevronRightIcon color="white" />}>
        <BreadcrumbItem data-testid="bcitem" key={0}>
          <BreadcrumbLink opacity={0.7} href="/" color="white">
            <FontAwesomeIcon width="15px" height="15px" icon={faHouse} />
          </BreadcrumbLink>
        </BreadcrumbItem>
        {breadcrumbsList}
      </Breadcrumb>
    </Box>
  ) : null;

  return breadcrumb;
};
export default Breadcrumbs;
